import { IColumns } from '../../../../components/Dashboard/TableSmall'

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: 'trades-history-by-user',
  columns: [
    {
      id: 'type',
      label: 'TYPE',
      format: (value: string) => value.charAt(0).toUpperCase() + value.slice(1),
    },
    {
      id: 'amount',
      label: 'AMOUNT',
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      format: (value: number) => {
        const newValue = value.toFixed(2).toString().split('.')
        newValue[0] = newValue[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        return `$${newValue.join(',')}`
      },
    },
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'status',
      label: 'STATUS',
      format: (value: string) => value.charAt(0).toUpperCase() + value.slice(1).replaceAll('_', ' '),
    },
    {
      id: 'timestamp',
      label: 'DATE',
      // eslint-disable-next-line
      format: (value: string) => {
        const newDate = new Date(value)
        return newDate.toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
      },
    },
  ],
}
